import React, { Fragment, useEffect, useRef, useState } from "react";
import debounce from 'lodash/debounce';
import { Button, FormGroup, Label } from 'reactstrap';
import Select, { components } from "react-select";
import { codeWithColourAutoSuggestion } from "../../../../../services/manage-product/productService";

const AvailableDifferenceFabric = (props) => {
    const { getValues, setValue, trigger, errors } = props;

    const [availableInDifferenceFabricOptions, setAvailableInDifferenceFabricOptions] = useState([]);
    const [pageAvailableInDifferenceFabric, setPageAvailableInDifferenceFabric] = useState(1);
    const [hasMoreAvailableInDifferenceFabric, setHasMoreAvailableInDifferenceFabric] = useState(true);
    const [loadingAvailableInDifferenceFabric, setLoadingAvailableInDifferenceFabric] = useState(false);
    const [queryAvailableInDifferenceFabric, setQueryAvailableInDifferenceFabric] = useState('');

    // Fetch functions (copy from general.jsx, but use your API import)
    const fetchAvailableInDifferenceFabricOptions = async (inputValue, page) => {
        if (loadingAvailableInDifferenceFabric || !hasMoreAvailableInDifferenceFabric) return;
        setLoadingAvailableInDifferenceFabric(true);
        try {
            let searchData = { 
                q: inputValue, 
                page: page, 
                page_size: 10,
                exclude_ids: getValues("available_difference_fabrics").map(c => c.id)  // Exclude already selected difference fabrics
            };
            const response = await codeWithColourAutoSuggestion(searchData);
            const newOptions = response.response;
            setAvailableInDifferenceFabricOptions(prevOptions => (page === 1 ? newOptions : [...prevOptions, ...newOptions]));
            setHasMoreAvailableInDifferenceFabric(newOptions.length === 10);
            setPageAvailableInDifferenceFabric(page + 1);
            setLoadingAvailableInDifferenceFabric(false);
        } catch (error) {
            setLoadingAvailableInDifferenceFabric(false);
            console.error('Error fetching availableInDifferenceFabric options:', error);
        }
    };
    
    // Debounced fetch
    const debouncedFetchAvailableInDifferenceFabricOptions = React.useCallback(debounce((inputValue, page) => fetchAvailableInDifferenceFabricOptions(inputValue, page), 500), []);

    // Input change handlers
    const handleInputChangeAvailableInDifferenceFabric = (inputValue) => {
        setPageAvailableInDifferenceFabric(1);
        setHasMoreAvailableInDifferenceFabric(true);
        setQueryAvailableInDifferenceFabric(inputValue);
        debouncedFetchAvailableInDifferenceFabricOptions(inputValue, 1);
    };

    
    // Infinite scroll handlers
    const handleMenuScrollToBottomAvailableInDifferenceFabric = () => {
        if (hasMoreAvailableInDifferenceFabric) {
            fetchAvailableInDifferenceFabricOptions(queryAvailableInDifferenceFabric, pageAvailableInDifferenceFabric);
        }
    };
    
    // Menu open handlers
    const handleMenuOpenAvailableInDifferenceFabric = () => {
        fetchAvailableInDifferenceFabricOptions(queryAvailableInDifferenceFabric, 1);
    };


    return (
        <FormGroup>
            <Label className="form-label">Also Available in Difference Fabric</Label>
            <Select
                placeholder="Select Difference Fabrics"
                isMulti
                options={availableInDifferenceFabricOptions}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.name}
                value={(getValues("available_difference_fabrics") || [])}
                onChange={selected => { setValue("available_difference_fabrics", selected); trigger("available_difference_fabrics"); }}
                onInputChange={handleInputChangeAvailableInDifferenceFabric}
                onMenuScrollToBottom={handleMenuScrollToBottomAvailableInDifferenceFabric}
                onMenuOpen={handleMenuOpenAvailableInDifferenceFabric}
                isLoading={loadingAvailableInDifferenceFabric}
                className={errors.available_difference_fabrics ? "is-invalid" : ""}
                noOptionsMessage={() => 'No product found'}
                isClearable={true}
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (_props) => {
                        return null;
                        // return getValues("available_difference_fabrics").length > 0 ? null : <components.DropdownIndicator {..._props} />;
                    }
                }}
            />
            <div className="invalid-feedback">{errors.available_difference_fabrics?.message}</div>
        </FormGroup>
    );
};

export default AvailableDifferenceFabric;
